import { Link } from "react-router-dom";
import {bustArr, shopInfo, rootUri} from "./defines";

// api取得渡す可能性があるものは、ifで初回レンダリングエラー回避.
export function nl2br(words){
    const sliced = words.split(/\n/)

    return sliced.map((w)=> <>{w}<br /></>)
}
export function calender(){
    let weeks = []
    for(let i=0; i<7; i++){
        var nowD = new Date();
        nowD.setDate(nowD.getDate() + i);

        const y = nowD.getFullYear()
        const m = 1 + nowD.getMonth()
        const d = nowD.getDate()
        const w = nowD.getDay()
        weeks.push({year: y, month: m, day: d, week: w})
    }
    return weeks
}
const weekArr = ["日", "月", "火", "水", "木", "金", "土"]
// ↓備忘録 api取得先
export function makeCalenderLink(calenderArr, selectedWeek){
    const res = (dayArr) =>{
        let classN = "day"
        if(selectedWeek == dayArr.week){ classN += " selected" }
        return <a className={classN} href={`/schedule/${dayArr.year}-${dayArr.month}-${dayArr.day}`}>{dayArr.month}月{dayArr.day}日({ weekArr[dayArr.week] })</a> }

    return calenderArr.map((day)=> res(day))
}


// 以下view系
export function h2Unlinked(title){
    if(title){
        return(<div className="wrapper-title"><h2 className="title">{title}</h2></div>) }
    }

export function h2Linked(title, subtitle, link, blank=false){
    if(title){
        let linkEl = (<Link to={link}>{subtitle}</Link>);
        if(blank === true){
            linkEl = (<Link to={link}
                        target="_blank" rel="noreferrer noopener">{subtitle}</Link>); }

        return(
            <div className="wrapper-title">
                <h2 className="title">{title}</h2>
                <nav>{ linkEl }</nav>
            </div>
            );
    }
}

export function castBody(cBody){
    if(cBody){
        return(
            <p className="body">
                <span>T{cBody.t !== 0 ? cBody.t : "-"} </span>
                <span>B
                    {Number(cBody.b)>0 ? cBody.b : "-"}
                    {cBody.cup&& `(${cBody.cup})`}
                </span>
                <span>W{cBody.w !== 0 ? cBody.w : "-"} </span>
                <span>H{cBody.h !== 0 ? cBody.h : "-"} </span>
            </p>
        );
    }
}

export function castCard(cData){

    const schedule = cData.is_work_day
            ? <time className="sc-time">{cData.schedule.start} ~ {cData.schedule.end}</time>
            : <></>

    const imgPath=cData.photo.has_photo
            ? `${rootUri}/d/p${cData.id}_1.jpg`
            : `${rootUri}/img/nophoto.jpg`

    return(
        <Link to={"/profile/" + cData.id}>
            <figure>
                <img src={imgPath} />
                <figcaption className="txt-center">
                    <div className="info">
                        <h3 className="name">
                            {cData.cast_name} {Number(cData.age)>0 && `(${cData.age})`}
                        </h3>
                        {castBody(cData.body)}
                        <div className="btn-wrap">
                            {cData.is_vip               && <span class="btn vip">VIP</span>}
                            {cData.is_newface           && <span class="btn new">新人</span>}
                            {cData.is_recommend         && <span class="btn reco">イチ推し</span>}
                            {Boolean(cData.has_diary)   && <span class="btn diy">写メ日記</span>}
                            {Boolean(cData.url_mov)     && <span class="btn mov">動画</span>}
                            {Boolean(cData.has_gravures)  && <span class="btn gravures">グラビア</span>}
                        </div>
                    </div>
                    {schedule}
                </figcaption>
            </figure>
        </Link>
    );
}
export function diaryArticle(json){
    if(json != undefined && json !=null){
        return (
            <li key={json.url_img} className="content">
                <a href={json.url_link} target="_blank" rel="noreferrer noopener">
                    <div className="wrappar-img"><img src={json.url_img} /></div>
                    <h3>{json.title}</h3>
                </a>
            </li>
        )
    }
}


export function telBlockPcHeader(){
    return (
        <div className="tel-block-pc pc">
            <p><a href={"tel:" + shopInfo.tel} id="tel_1">TEL :<span className="large">{shopInfo.tel}</span></a></p>
            <p>営業時間 : {shopInfo.openTime}</p>
        </div>
    )
}

export function telBlockPcFooter(){
    return (
        <div className="tel-block-pc pc">
            <p><a href={"tel:" + shopInfo.tel} id="tel_9">TEL :<span className="large">{shopInfo.tel}</span></a></p>
            <p>営業時間 : {shopInfo.openTime}</p>
        </div>
    )
}

export function NavLinkMaker(props){

    const tagTempletes = {

        vanilla: info =>{
            return <a rel="nofollow" href={info.path} target="_blank">{props.children}</a>
        },
    }

    const tagMaker=(data)=>{
        return (
            data.blank
                ? <a href={data.path} target="_blank" rel="noreferrer noopener">{props.children}</a>
                : <Link to={data.path}>{props.children}</Link>
        )
    }

    return (
        props.data.tagForced
            ? tagTempletes[props.data.requireTag](props.data)
            : tagMaker(props.data)
    )
}